/* eslint-disable no-console */
<template>
  <div>
    <div class="card z-depth-5 p-3">
      <h4 class="text-center font-weight-bold py-3">Edit Student</h4>
      <div>
        <!-- Default form login -->
        <form class="border border-light p-5">
          <div class="row">
            <div class="form-group col-md-12">
              <label>Username</label>
              <input
                type="text"
                ref="username"
                :value="student.username"
                class="form-control mb-4"
                placeholder="Username"
              />
            </div>
            <div class="form-group col-md-6">
              <label>First Name</label>
              <input
                type="text"
                ref="first_name"
                :value="student.first_name"
                class="form-control mb-4"
                placeholder="First Name"
              />
            </div>
            <div class="form-group col-md-6">
              <label>Last Name</label>
              <input
                type="text"
                ref="last_name"
                :value="student.last_name"
                class="form-control mb-4"
                placeholder="Last Name"
              />
            </div>
            <div class="form-group col-md-6">
              <label>Name</label>
              <input
                type="text"
                ref="name"
                :value="student.name"
                class="form-control mb-4"
                placeholder="Name"
              />
            </div>
            <div class="form-group col-md-6">
              <label>School Grade</label>
              <input
                type="email"
                ref="school_grade"
                :value="student.school_grade"
                class="form-control mb-4"
                placeholder=""
              />
            </div>
            <div class="form-group col-md-6">
              <label>Group</label>
              <select class="form-control mb-4" ref="group">
                <option selected disabled>-- Select A Group --</option>
                <option
                  v-for="group in totalGroups"
                  :key="group._id"
                  v-bind:value="group.group"
                  :selected = "student.group == group.group"
                >
                Group  {{ group.group }}
                </option>
              </select>
            </div>
            <div class="form-group col-md-6">
              <label>Class</label>
              <input
                type="text"
                ref="class"
                :value="student.class"
                class="form-control mb-4"
                placeholder=""
              />
            </div>
            <div class="form-group col-md-6">
              <label>Guardian Name</label>
              <input
                type="text"
                ref="guardian_name"
                :value="student.guardian_name"
                class="form-control mb-4"
                placeholder=""
              />
            </div>
            <div class="form-group col-md-6">
              <label>Guardian Phone</label>
              <input
                type="text"
                ref="guardian_phone"
                :value="student.guardian_phone"
                class="form-control mb-4"
                placeholder=""
              />
            </div>
            <div class="form-group col-md-6">
              <label>Guardian Email</label>
              <input
                type="email"
                ref="guardian_email"
                :value="student.guardian_email"
                class="form-control mb-4"
                placeholder=""
              />
            </div>
          </div>

          <router-link :to="{ name: 'EditProgress', params : {student_id : student._id} }">
            <button class="btn btn-primary btn-block my-4">
              Edit Progress
            </button>
          </router-link>
          <!-- Sign in button -->
          <button class="btn btn-info btn-block my-4" @click.prevent="updateStudent()">
            Update Account
          </button>
        </form>
        <!-- Default form login -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "EditStudent",
  components: {},
  data() {
    return {
      totalGroups: [],
      user_id: this.$route.params.student_id,
      fastAdminToken: localStorage.getItem("fastAdminToken"),
      student: [],
    };
  },
  methods: {
    updateStudent() {
      if (
        this.$refs.first_name.value == "" ||
        this.$refs.last_name.value == "" ||
        this.$refs.class.value == ""
      ) {
        this.$toast.open({
          message: "ERROR : All Fields Are Required",
          type: "error",
        });
      } else {
        let data = {
          username: this.$refs.username.value,
          first_name: this.$refs.first_name.value,
          last_name: this.$refs.last_name.value,
          name: this.$refs.name.value,
          group: this.$refs.group.value,
          classL: this.$refs.class.value,
          school_grade: this.$refs.school_grade.value,
          guardian_name: this.$refs.guardian_name.value,
          guardian_phone: this.$refs.guardian_phone.value,
          guardian_email: this.$refs.guardian_email.value,
        };
        const config = {
          headers: {
            Authorization: "Bearer " + this.student.token,
            "Content-Type": "application/json",
          },
        };
        this.$toast.open({
          message: "Processing : Updating student Please Wait...",
          type: "info",
        });
        axios
          .post(this.$apiURI + "/account/update", data, config)

          .then((response) => {
            if (response.data.error) {
              this.$toast.open({
                message: "Error : " + response.data.message,
                type: "error",
              });
            } else {
              this.$toast.open({
                message: "Student Updated Successfully",
                type: "success",
              });
            }
          })
          .catch((error) => {
            this.$toast.open({
              message: "Error : " + error.response.data.message,
              type: "error",
            });
          });
      }
    },
  },
  mounted() {
    this.$toast.open({
      message: "Processing : Loading Plan Please Wait...",
      type: "info",
    });

    const config = {
      headers: {
        Authorization: "Bearer " + this.fastAdminToken,
        "Content-Type": "application/json",
      },
    };
    axios
      .get(this.$apiURI + "/account/clone/" + this.user_id, config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          // eslint-disable-next-line no-console
          // console.log(response.data.data.students)
          this.student = response.data.data;
          // this.planTarget = response.data.data.target
        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });

    axios
      .get(this.$apiURI + "/groups", config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          let groups = response.data.data.groups;
          this.totalGroups = groups;
        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });
  },
};
</script>
